import * as React from 'react'
import PropTypes from 'prop-types'

const TOGGLE_INTERVAL = 3000

const StatusToggler = ({ children }) => {
  const [firstChild, secondChild] = children
  const bothStatusComponents =
    React.isValidElement(firstChild) && React.isValidElement(secondChild)

  const [firstOrSecond, setFirstOrSecond] = React.useState(true)

  React.useEffect(() => {
    let toggleStatussesInterval
    if (bothStatusComponents) {
      toggleStatussesInterval = setInterval(() => {
        setFirstOrSecond((firstOrSecond) => !firstOrSecond)
      }, TOGGLE_INTERVAL)
    }
    return () => {
      window.clearTimeout(toggleStatussesInterval)
    }
  }, [bothStatusComponents])

  if (!bothStatusComponents) {
    return children
  }

  return firstOrSecond ? firstChild : secondChild
}

StatusToggler.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default StatusToggler
